import { Immutable } from "immer";
import React, { type JSX } from "react";
import SVG from "react-inlinesvg";
import { ChatLink } from "tsi-common-react/src/components/ChatLink/index";
import { RichText } from "tsi-common-react/src/components/RichText/index";
import { FinancingPlan } from "tsi-common-react/src/models/financing";
import { usePageSetting } from "tsi-common-react/src/utils/settings";
import { usePageURL } from "tsi-common-react/src/utils/urls";
import { t } from "ttag";

import { richT } from "@thelabnyc/thelabui/src/utils/richText";

import iconSpeechBubblesTalk from "../../../assets/svg/speech-bubbles-talk.svg";
import { BasketFinePrint } from "../BasketFinePrint";

type IProps = Immutable<{
    plans: readonly FinancingPlan[];
    isMobile: boolean;
    cartID?: string;
}>;

export const BasketSidebarContent = (props: IProps) => {
    const contactURL = usePageURL("contact_us_form");
    const homeURL = usePageURL("home");
    const supportPhoneNumberLink = usePageSetting(
        "support_website_phone_number_link",
    );
    const supportPhoneNumberDisplay = usePageSetting(
        "support_website_phone_number_display",
    );
    const enableBasketSidebarQuestionsBlock = usePageSetting(
        "enable_basket_sidebar_questions_block",
    );
    const basketSidebarExtraContent = usePageSetting(
        "basket_sidebar_extra_content",
    );
    const ctaFmtString = t`<chatlink>Chat</chatlink> or <phonelink>Call</phonelink> and reference <basketid />.`;
    const msg = richT(ctaFmtString, {
        chatlink: (children) => (
            <ChatLink
                className="basket-summary__help--link"
                chatOnlineText={children}
                chatOfflineText={children}
                chatOfflineLink={contactURL || homeURL}
            />
        ),
        phonelink: (children) => (
            <strong>
                {children}&nbsp;
                <a href={supportPhoneNumberLink || ""}>
                    {supportPhoneNumberDisplay}
                </a>
            </strong>
        ),
        basketid: () => <strong>{props.cartID}</strong>,
    });

    let questionsBlock: JSX.Element | null = null;
    if (enableBasketSidebarQuestionsBlock) {
        questionsBlock = (
            <div className="basket-summary__help">
                <h3>
                    <SVG
                        className="basket-summary__help-icon"
                        src={iconSpeechBubblesTalk}
                        title={t`Speech Bubbles Icon`}
                    />
                    {t`Questions?`}
                </h3>
                <p>{msg}</p>
            </div>
        );
    }

    let finePrint: JSX.Element | null = null;
    if (props.isMobile) {
        finePrint = <BasketFinePrint plans={props.plans} />;
    }

    return (
        <div className="basket-summary__sidebar-content">
            {questionsBlock}
            <RichText html={basketSidebarExtraContent || ""} />
            {finePrint}
        </div>
    );
};
